export const productConstants = {
    SELECT_CHECKOUT_ITEM    : 'SELECT_CHECKOUT_ITEM',
    SELECTED_SERVICE_LIST:'SELECTED_SERVICE_LIST',
    SELECTED_CHECKOUT_LIST:'SELECTED_CHECKOUT_LIST',
    SELECTED_CLIENT:'SELECTED_CLIENT',
};
